export const CapacityConstants = {
  N_A: -1,
  UNLIMITED: null
};
